module.exports = __webpack_public_path__ + "img/exclamation-dark.ba178452.svg";